export const adaptMarketingSection = marketingSection => {
  if (!marketingSection) {
    return null;
  }

  const feeDetails = {
    additionalInformation: marketingSection.feeDetails.marketingFeeMessage.value,
    mark: marketingSection.feeDetails.mark.id,
    description: marketingSection.feeDetails.tierName,
    headerText: marketingSection.feeDetails.formattedFee,
  };

  const paymentDetails = {
    icon: marketingSection.paymentDetails?.icon?.id,
    description: marketingSection.paymentDetails?.value,
  };

  return {
    marketingItems: [feeDetails, ...(marketingSection.paymentDetails ? [paymentDetails] : [])],
    ...(marketingSection.title ? { sectionTitle: marketingSection.title.text } : {}),
  };
};

export const getMarketingSection = ratePlan => {
  if (ratePlan.marketingSection && ratePlan.marketingSection.feeDetails) {
    return ratePlan.marketingSection;
  }

  return null;
};
